import { useEffect, useState } from "react";
import { onMessage } from "firebase/messaging";
import { messaging } from "../firebase";

/**
 * Hook ini TIDAK minta permission dan TIDAK register device baru.
 * Dia cuma "dengerin" — kalau device ini KEBETULAN sudah pernah
 * diaktifkan sebelumnya (lewat useFcmRegistration di halaman akun),
 * OTP yang dikirim ke device ini akan otomatis ketangkep di sini dan
 * bisa langsung diisikan ke form, tanpa user perlu buka notifikasi manual.
 *
 * Kalau device ini belum pernah diaktifkan, hook ini gak akan pernah
 * nerima apa-apa (memang gak ada push yang ditujukan ke device ini) —
 * itu normal, user tinggal cek OTP dari WA/Telegram seperti biasa.
 */
export function useOtpPushListener(isMain = false) {
  const [receivedCode, setReceivedCode] = useState(null);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    // Registrasi service worker (idempotent — aman dipanggil ulang)
    navigator.serviceWorker.register("/firebase-messaging-sw.js").catch(() => {
      // Device belum pernah kasih izin notifikasi — gak masalah,
      // berarti memang gak akan pernah nerima push, silent aja.
    });

    const unsubscribe = onMessage(messaging, (payload) => {  
      
      if (payload.data?.otp) {
        setReceivedCode(payload.data.otp);
      }

      const { title, body } = payload.notification || {};
      setNotification(payload.notification);

      // if (isMain){
      // new Notification(title || "Notifikasi baru", { body });
      // }

    });

    return () => unsubscribe();
  }, []);

  return { receivedCode, notification };
}
